import { render } from "./OrderReviewsForm.vue?vue&type=template&id=ec439db6&scoped=true"
import script from "./OrderReviewsForm.vue?vue&type=script&lang=js"
export * from "./OrderReviewsForm.vue?vue&type=script&lang=js"

import "./OrderReviewsForm.vue?vue&type=style&index=0&id=ec439db6&scoped=true&lang=css"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec439db6"]])

export default __exports__